/* istanbul ignore file */

export enum Aggregators {
    Sum = 'sum',
    Average = 'average',
    Min = 'min',
    Max = 'max',
    Count = 'count',
}

export enum AggregatorsNames {
    Sum = 'Sum',
    Average = 'Average',
    Min = 'Min',
    Max = 'Max',
    Count = 'Count',
}
